import { connect } from 'react-redux';
import { ISubCardIndicatorHOCProps } from './types';
import { SubCardIndicator } from '../components/SubCardIndicator';
import { ISubCardIndicatorEvents, ISubCardIndicatorFields } from '../components/types';
import { getCardFullName } from '../../../../../../../store/model/card/selectors/getCardFullName';
import { getCard } from '../../../../../../../store/model/selectors/getCard';
import { IApplicationState } from '../../../../../../../types/types';
import { onClick } from './events/onClick';

const mapStateToProps = (
    state: IApplicationState,
    { cardId }: ISubCardIndicatorHOCProps
): ISubCardIndicatorFields => {
    const { epicId } = getCard(state, cardId);
    return {
        epicName: getCardFullName(state, epicId),
    };
};

const mapDispatchToProps = (
    dispatch: any,
    { cardId }: ISubCardIndicatorHOCProps,
): ISubCardIndicatorEvents => {
    return {
        onClick: () => dispatch(onClick(cardId)),
    }
};

export const SubCardIndicatorHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(SubCardIndicator);

SubCardIndicatorHOC.displayName = 'SubCardIndicatorHOC';
